import translate from '@translate';
import React, { FC, useEffect } from 'react';
import Select, { OnChangeType, SelectValueType } from 'src/components/Select';
import { RootStoreType } from 'src/types/store';
import { useDispatch, useSelector } from 'react-redux';
import { getBalikovnaFetch } from 'src/resources/balikovna/reducer';

export interface BalikovnaSelectPropsType {
    onChange: OnChangeType;
    value: SelectValueType;
    error?: boolean;
    name?: string;
    label?: string;
    required?: boolean;
    disabled?: boolean;
    fullWidth?: boolean;
}

const BalikovnaSelect: FC<BalikovnaSelectPropsType> = (props) => {
    const dispatch = useDispatch();

    const data = useSelector((state: RootStoreType) => state.balikovna.data);
    const loading = useSelector((state: RootStoreType) => state.balikovna.loading);

    useEffect(() => {
        if (!data) {
            dispatch(getBalikovnaFetch());
        }
    }, [data]);

    const options = data || [];

    const isSet = !props.value || options?.filter((option: any): boolean => option.value === props.value).length;
    const allOptions = isSet
        ? options
        : [{ label: `${translate('messages.branchUnavailable')} (${props.value})`, value: props.value }, ...options];

    return (
        <Select
            options={allOptions}
            value={props.value}
            error={props.error}
            onChange={props.onChange}
            name={props.name}
            label={props.label}
            required={props.required}
            disabled={props.disabled}
            fullWidth={props.fullWidth}
            loading={loading}
            virtualized
        />
    );
};

export default BalikovnaSelect;
